import axios from 'axios'

// _t13st40q === shopToken

const state = {
    userShop: null,
    shopBillings: null,
    tempShopAccess: null,
}

const getters = {
    authShop (state) {
        // perfectly ensure user has signed in before granting access to shop
        if(state.userShop === null){
            return false
        }
        return true
    },
    userShop (state) {
        return state.userShop
    },
    shopBillings (state) {
        return state.shopBillings
    },
    tempShopAccess (state) {
        return state.tempShopAccess
    },
    // console.log(Object.assign({}, activeUser))
}

const actions = {

    // start shop signup
    async createShop({ _ }, shopObj) {
        let response = await axios.post('/shop/newShop', shopObj)
        if(response.data){
            // attempt launching the payment gateway url
            try {
                if(response.data.link !== null){
                    // redirect user to payment url to obtain transactionId for completeCreateShop
                    window.location = response.data.link
                }
            } catch (error) {}
        }
        return response.data
    },

    // complete shop signup
    async completeCreateShop({ dispatch }, shopObj) {
        /**
         * shopObj was re-built from the content of localStorage.removeItem('_s39cs25u')
         * now remove it from localStorage to prevent page loop when the axios result returns
         */
        localStorage.removeItem('_s39cs25u')
        let response = await axios.post('/shop/newShop', shopObj)
        if(!response.data.error){
            // fetch the updated user obj with shopOwner now true
            dispatch('updateProfile', shopObj)
            dispatch('fetchShop', shopObj) 
        }
        return response.data
    },

    // pay shop+ bill - renewal
    async payBill({ _ }, billObj) {
        let response = await axios.post('/billing/billPayment', billObj)
        if(response.data){
            // attempt launching the payment gateway url
            try {
                if(response.data.link !== null){
                    // redirect user to payment url to obtain transactionId for completePayBill
                    window.location = response.data.link
                }
            } catch (error) {}
        }
        return response.data
    },

    // complete pay shop+ bill - renewal
    async completePayBill({ dispatch }, billObj) {
        /**
         * billObj was re-built from the content of localStorage.removeItem('_s26pb17u')
         * now remove it from localStorage to prevent page loop when the axios result returns
         */
        localStorage.removeItem('_s26pb17u')
        let response = await axios.post('/billing/billPayment', billObj)
        if(!response.data.error){
            dispatch('fetchBillings', billObj) 
        }
        return response.data
    },

    // grant shop temporary access to allow bill payment
    async grantTempShopAccess({ commit }) {
        commit('TEMP_SHOP_ACCESS', true) 
    },
    
    // destroy shop temporary access after bill payment
    async destroyTempShopAccess({ commit }) {
        commit('TEMP_SHOP_ACCESS', null) 
    },
    
    // shop signin
    async fetchShop({ commit }, userObj) {
        commit('SET_SHOP', null)
        let response = await axios.post('/shop/myShop', userObj)
        if(!response.data.error){
            localStorage.setItem('_t13st40q', response.data.result.token)
            commit('SET_SHOP', response.data.result) 
        }
        return response.data
    },

    // shop signout
    async exitShop({ commit, getters }) {
        let userObj = {
            userId: getters.user._id
        }
        await axios.post('/shop/closeShop', userObj)
        localStorage.removeItem('_t13st40q')
        return commit('SET_SHOP', null)
    },

    // shop changes 
    async editShop({ dispatch }, shopObj) {
        let response = await axios.put('/shop/modifyShop', shopObj)
        if(!response.data.error){
            // fetch the updated shop obj
            dispatch('fetchShop', shopObj) 
        }
        return response.data
    },
    
    // forgot passcode 
    async forgotPasscode({ _ }, userObj) {
        let response = await axios.put('/security/passcodeRecovery', userObj)
        return response.data
    },
    
    // reset passcode 
    async resetPasscode({ _ }, passcodeObj) {
        let response = await axios.put('/shop/passcodeReset', passcodeObj)
        return response.data
    },
    
    // shop billings 
    async fetchBillings({ commit }, userObj) {
        let response = await axios.post('/billing/myBills', userObj)
        if(!response.data.error) {
            commit('SHOP_BILLINGS', response.data.result)
        }
        return response.data
    },

}

const mutations = {
    SET_SHOP: (state, userShop) => (state.userShop = userShop),
    SHOP_BILLINGS: (state, shopBillings) => (state.shopBillings = shopBillings),
    TEMP_SHOP_ACCESS: (state, tempShopAccess) => (state.tempShopAccess = tempShopAccess),
}

export default {
    state,
    getters,
    actions,
    mutations
}